import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Order, OrderClass, OrderValueClass } from "../../../../Constant";
import { ORDER_DATA, ORDER_LIST } from "../../../../Data/UiKit/Grid";
import GridCommonCardFooter from "../Common/GridCommonCardFooter";

const OrderCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={Order} span={ORDER_DATA} />
        <CardBody className="grid-showcase">
          <Row className="g-2">
            <Col xs="3" className="order-3"><span>First Item (order-3)</span></Col>
            {ORDER_LIST.map(({ extraSmallSize, smallSize, item, order }, index) => (
              <Col xs={extraSmallSize} sm={smallSize && smallSize} className={order} key={index}><span>{item} ({order})</span></Col>
            ))}
          </Row>
        </CardBody>
        <GridCommonCardFooter className={OrderClass} valueClass={OrderValueClass} />
      </Card>
    </Col>
  );
};

export default OrderCart;
